// GathrXR Creator Council — post-purchase thank-you page.
// This is the success URL for the Stripe Payment Links
// (set Payment Link success URL to https://gathrxr.com/council/welcome).
// The buyer is instructed to sign in / create their account with the SAME
// email used at checkout so their membership auto-links via claim_council_membership().

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown, ArrowRight } from 'lucide-react';
import './LandingPage.css';

const CouncilWelcome: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-container" style={{ minHeight: '100dvh' }}>
      <div className="landing-glow" />
      <div className="landing-content" style={{ paddingBottom: 60 }}>
        <nav className="landing-nav" style={{ marginBottom: 8 }}>
          <div className="nav-logo" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
            Gathr<span className="nav-logo-accent">XR</span>
          </div>
        </nav>

        <section style={{ textAlign: 'center', padding: '80px 0 24px', maxWidth: 620, margin: '0 auto' }}>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 76,
              height: 76,
              borderRadius: '50%',
              background: 'rgba(0,194,179,0.12)',
              border: '1px solid rgba(0,194,179,0.4)',
              color: '#ffd166',
              marginBottom: 24,
            }}
          >
            <Crown size={34} />
          </div>

          <h1 style={{ fontSize: 44, fontWeight: 800, color: 'rgba(234,246,248,0.95)', letterSpacing: '-1.2px', margin: '0 0 16px', lineHeight: 1.08 }}>
            Welcome to the <span className="hero-title-accent">Creator Council</span>
          </h1>

          <p style={{ fontSize: 18, color: 'rgba(234,246,248,0.65)', lineHeight: 1.65, margin: '0 0 18px' }}>
            Your founding contribution is confirmed — thank you for shaping GathrXR
            from the beginning. We just sent a welcome email with your seat details.
          </p>

          <div
            style={{
              background: 'rgba(0,194,179,0.07)',
              border: '1px solid rgba(0,194,179,0.3)',
              borderRadius: 16,
              padding: '22px 26px',
              margin: '28px auto 32px',
              textAlign: 'left',
              maxWidth: 520,
            }}
          >
            <div style={{ fontSize: 12, letterSpacing: '0.08em', color: '#00c2b3', fontWeight: 700, marginBottom: 10 }}>
              ONE QUICK STEP
            </div>
            <p style={{ fontSize: 15, color: 'rgba(234,246,248,0.85)', lineHeight: 1.6, margin: 0 }}>
              Sign in — or create your account — using the{' '}
              <strong style={{ color: '#00c2b3' }}>same email address you used at checkout</strong>.
              Your membership and monthly AI resources link to your account
              automatically the moment you do.
            </p>
          </div>

          <button
            onClick={() => navigate('/dashboard')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 10,
              padding: '15px 30px',
              borderRadius: 999,
              border: 'none',
              cursor: 'pointer',
              fontSize: 16,
              fontWeight: 700,
              fontFamily: 'Outfit, sans-serif',
              color: '#fff',
              background: 'var(--gx-gradient)',
              boxShadow: '0 12px 36px rgba(0,194,179,0.25)',
            }}
          >
            Go to your dashboard <ArrowRight size={18} />
          </button>
        </section>

        <footer className="landing-footer">
          <span>&copy; {new Date().getFullYear()} GathrXR. All rights reserved.</span>
          <div className="footer-links">
            <a href="/">Home</a>
            <a href="mailto:support@gathrxr.com">Contact</a>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default CouncilWelcome;
